import { KPIDirection, KPIUnit } from "../types";
import { formatValue } from "./toDashboardKPI";

export type ThresholdZone = "On target" | "Watch" | "Off target";

export interface BoundaryWording {
  onTarget: string;
  offTarget: string;
}

/** A value exactly on a boundary falls in the worse zone. */
export const describeBoundaryWording = (
  direction: KPIDirection,
): BoundaryWording =>
  direction === "lower_is_better"
    ? { onTarget: "below", offTarget: "at or above" }
    : { onTarget: "above", offTarget: "at or below" };

export const describeWatchRange = (
  watchStartsAt: number,
  offTargetStartsAt: number,
  unit: KPIUnit,
  direction: KPIDirection,
): string => {
  const watch = formatValue(watchStartsAt, unit);
  const offTarget = formatValue(offTargetStartsAt, unit);

  return direction === "lower_is_better"
    ? `${watch}–${offTarget}`
    : `${offTarget}–${watch}`;
};

export const classifyThresholdZone = (
  value: number,
  watchStartsAt: number,
  offTargetStartsAt: number,
  direction: KPIDirection,
): ThresholdZone => {
  if (direction === "lower_is_better") {
    if (value < watchStartsAt) {
      return "On target";
    }

    return value < offTargetStartsAt ? "Watch" : "Off target";
  }

  if (value > watchStartsAt) {
    return "On target";
  }

  return value > offTargetStartsAt ? "Watch" : "Off target";
};
